// ** React Imports
import ReactDOM from "react-dom";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

// ** Ant Design
import "antd/dist/antd.css";

// ** Apex Chart
import "@styles/react/libs/charts/apex-charts.scss";

// ** image-lightbox
import "react-image-lightbox/style.css";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";

// ** Lazy load app
import Bootstrap from "./bootstrap";

ReactDOM.render(<Bootstrap />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
